export function joinToString(strings, separator) {
    return strings
        .filter((s) => s != null)
        .map((s) => (typeof s === 'number' ? s.toString() : s === null || s === void 0 ? void 0 : s.trim()))
        .filter((s) => s)
        .join(separator);
}
export function joinLabels(...labels) {
    return joinToString(labels, ' - ');
}
export function joinValues(values) {
    return joinToString(values, ', ');
}
export function getLabelAndValuePairsFromChildProps(props, labelPrefix) {
    if (props.childProps) {
        return props.childProps.flatMap((childProp) => {
            if (childProp.widget.getLabelValueAsTextPairs) {
                return childProp.widget.getLabelValueAsTextPairs(childProp, labelPrefix);
            }
            else {
                return [];
            }
        });
    }
    else {
        return [];
    }
}
export function getLabelAndValuePairsFromChildDynamicRows(props, labelPrefix) {
    if (props.childDynamicRows) {
        return props.childDynamicRows.flatMap((row, rowIndex) => {
            return row.childProps.flatMap((childProp) => {
                if (childProp.widget.getLabelValueAsTextPairs) {
                    return childProp.widget.getLabelValueAsTextPairs(childProp, joinLabels(labelPrefix, rowIndex + 1));
                }
                else {
                    return [];
                }
            });
        });
    }
    else {
        return [];
    }
}
export function getLabelAndValuePair(label, value) {
    if (value != null) {
        const text = typeof value === 'number' ? value.toString() : value.trim();
        if (text) {
            return { label, text: text };
        }
    }
    return undefined;
}
export function getLabelAndValuePairs(label, text) {
    const pair = getLabelAndValuePair(label, text);
    if (pair) {
        return [pair];
    }
    else {
        return [];
    }
}
